module.exports = __webpack_public_path__ + "media/src/office/images/avatar-b7c1d98ae0805565db88ece5bcb2c013.png";